import Vue from 'vue';
import { $httpChangiRecommends } from '@/core/api';
import NewPasswordForm from './NewPasswordForm.vue';
import { AuthMode } from '../auth-mode.enum';
export default Vue.extend({
    components: { NewPasswordForm },
    data() {
        return {
            isLoading: false,
            title: 'Create new password',
            apiErrors: {},
            Mode: AuthMode,
        };
    },
    methods: {
        onFormSubmitted(email) {
            this.isLoading = true;
            $httpChangiRecommends.api
                .ChangiRecommendsForgotPassword(email)
                .then(({ data }) => {
                this.$emit('newPasswordSuccess');
            })
                .catch(({ data }) => {
                const { errors } = data;
                if (!errors) {
                    return;
                }
                this.apiErrors = {
                    email: errors?.email || [],
                };
            })
                .finally(() => (this.isLoading = false));
        },
        onClearApiErrors(formControlName) {
            this.apiErrors[formControlName] = [];
        },
    },
});
